import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { FC, ReactNode } from 'react'
import { PageDetails } from '@config/typing'
import useAdobeAnalytics from '@analytics/adobe'
import useHeaderDetails from '@header/useHeaderDetails'
import { PATIENTS } from '../../route.const'
interface ScreenInfoProps extends PageDetails<string[], string> {
  hideSubtext?: boolean
  action: ReactNode
  actionLabel?: string
}
const ScreenInfo: FC<ScreenInfoProps> = ({
  title,
  subText,
  hideSubtext,
  bodyText,
  action,
}) => {
  const { trackLink } = useAdobeAnalytics()
  const { role, login } = useHeaderDetails()
  const isPatient = role === PATIENTS

  return (
    <Box
      sx={{
        py: { xs: 2, sm: 2, md: 7, lg: 7 },
        px: {
          xs: 2,
          sm: 2,
          md: 10.5,
          lg: 10.5,
          xl: 10.5,
        },
      }}
    >
      <Typography variant={'h1'} pb={2}>
        {title}
      </Typography>

      {subText !== '' && (
        <Typography
          variant={'body1'}
          pb={2}
          sx={{
            display: { xs: hideSubtext ? 'none' : 'block', sm: 'block' },
            fontWeight: 500,
          }}
        >
          {subText}
        </Typography>
      )}

      {bodyText.map((text, index) => (
        <Typography
          variant={'body2'}
          pb={2}
          key={index}
          dangerouslySetInnerHTML={{ __html: text }}
          onClick={(e) => {
            const target = e.target as HTMLElement
            if (target.tagName === 'A') {
              const href = target.getAttribute('href')
              let trackingName = text
              const location = isPatient
                ? 'om_pa_terms_of_service_modal'
                : 'om_cl_welcome(terms_of_service)'

              if (href === '/privacy-policy') {
                trackingName = isPatient
                  ? 'om_pa_link_click:privacy_policy'
                  : 'om_cl_link_click:privacy_policy'
              } else if (href === '/terms-of-use') {
                trackingName = isPatient
                  ? 'om_pa_link_click:terms_of_use'
                  : 'om_cl_link_click:terms_of_use'
              }

              trackLink(
                {
                  name: trackingName,
                  location: location,
                  type: 'external',
                },
                {
                  loginStatus: login ? 'logged in' : 'logged out',
                  userType: role,
                }
              )
            }
          }}
        />
      ))}

      <Box>{action}</Box>
    </Box>
  )
}

export default ScreenInfo
